import React from 'react';
import faqList from '../data/Faq'; // faqList 데이터 경로를 조정하세요.

const FaqSection = () => {
  // 아코디언 토글 로직은 FaqSection 내부에서 관리하는 것이 더 적절합니다.
  // 각 FAQ 항목의 상태(열림/닫힘)를 관리할 수 있습니다.
  const toggleAccordion = (event) => {
    const header = event.currentTarget; // 클릭된 헤더 요소
    const content = header.nextElementSibling; // 다음 형제 요소인 content
    const arrow = header.querySelector(".arrow"); // 헤더 내의 화살표

    if (content && arrow) { // 요소들이 존재하는지 확인
      content.classList.toggle("active");
      arrow.classList.toggle("rotated");
    }
  };

  return (
    <div className="accordion">
      {faqList.map((item, index) => (
        <div className="accordion-item" key={index}>
          <div className="accordion-header" onClick={toggleAccordion}> {/* 클릭 이벤트 추가 */}
            <div className="aco_tit">{item.question}</div>
            <div className="arrow"></div> {/* 화살표 아이콘 */}
          </div>
          <div className="accordion-content">
            <div className="aco_con">{item.answer}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FaqSection;